import { ColDef } from 'ag-grid-enterprise';
import { CapTableResponse } from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { formatCurrency } from '~/lib/money';

export const colDefsPortfolioCapTable: ColDef<CapTableResponse>[] = [
  {
    field: 'shareholderName',
    headerName: 'Shareholder',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left capitalize',
    wrapText: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'shareholderType',
    headerName: 'Type',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'shareClass',
    headerName: 'Share Class',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    filter: true,
    valueFormatter: (p) => (p.value ? p.value.replace('_', ' ') : '-'),
  },
  {
    field: 'ownership',
    headerName: 'Ownership',
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      p.value ? parseFloat(p.value).toFixed(2) + '%' : '-',
  },
  {
    field: 'shares',
    headerName: 'Shares',
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      p.value
        ? new Intl.NumberFormat('en-GB').format(
            Number(parseFloat(p.value).toFixed(0)),
          )
        : '-',
  },
  {
    field: 'schema',
    headerName: 'Schema',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'valuation',
    headerName: 'Valuation',
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      typeof p.value === 'number'
        ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
        : '-',
  },
];
